<template>
  <!-- 工程管理-回收站 author: zhangxiaofeng-->
  <div>
    <recycle-bin v-if="HasUsedWorkspace" :tabletype="$route.path === '/enterprise/recycle' ? 'companyList' : 'projectList'"
                 :forSpaceEnterprise="false"></recycle-bin>
    <LoadingGif :loadingShow=loading></LoadingGif>
  </div>
</template>
<script>
import RecycleBin from '_c/common/RecycleBin'
import LoadingGif from "_c/loading-gif/index.vue"
import spaceService from "service/space"
export default {
  name: 'Recycle',
  components: {
    RecycleBin,
    LoadingGif
  },
  data () {
    return {
      HasUsedWorkspace: false,
      loading: true
    }
  },
  created () {
    this.showGuide()
  },
  methods: {
    showGuide () {
      // 员工资料库是否使用过企业空间
      spaceService.getHasUsedWorkspace().then((result) => {
        if (result && result.data) {
          this.HasUsedWorkspace = true
        } else {
          this.$router.push({
            path: '/space2/guide'
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
